import React from 'react';
import { Zap, AlertTriangle } from 'lucide-react';

const ConsumptionBar = ({ currentCount, limit, onUpgradeClick }) => {
  const percentage = Math.min((currentCount / limit) * 100, 100);
  const isAtLimit = currentCount >= limit;
  const isNearLimit = currentCount >= limit * 0.8 && !isAtLimit;

  // Don't show if not near or at limit
  if (!isAtLimit && !isNearLimit) {
    return null;
  }

  return (
    <div className={`rounded-xl p-4 mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 ${
      isAtLimit 
        ? 'bg-red-50 border border-red-200' 
        : 'bg-amber-50 border border-amber-200'
    }`}>
      <div className="flex items-center gap-3">
        <AlertTriangle size={20} className={`flex-shrink-0 ${isAtLimit ? 'text-red-500' : 'text-amber-500'}`} />
        <div>
          <p className={`font-medium ${isAtLimit ? 'text-red-700' : 'text-amber-700'}`}>
            {isAtLimit ? 'Stash limit reached!' : 'Running low on space!'}
          </p>
          <p className={`text-sm ${isAtLimit ? 'text-red-600' : 'text-amber-600'}`}>
            {isAtLimit 
              ? `You have ${currentCount} items. Upgrade to add more.`
              : `Using ${currentCount} of ${limit} items (${Math.round(percentage)}%). Upgrade to grow your collection.`
            }
          </p>
        </div>
      </div>
      <button
        onClick={onUpgradeClick}
        className={`flex items-center justify-center gap-2 px-4 py-2 text-white text-sm font-medium rounded-lg transition-colors whitespace-nowrap ${
          isAtLimit 
            ? 'bg-red-500 hover:bg-red-600' 
            : 'bg-amber-500 hover:bg-amber-600'
        }`}
        data-testid="consumption-upgrade-btn"
      >
        <Zap size={16} />
        {isAtLimit ? 'Upgrade Now' : 'View Upgrades'}
      </button>
    </div>
  );
};

export default ConsumptionBar;
